import React from 'react';
import styled from 'styled-components';
import BaseReactMarkdown from 'react-markdown';

const ReactMarkdown = styled(BaseReactMarkdown)`
  border: none;
  font-family: inherit;

  img {
    letter-spacing: 0 !important;
    background-size: contain !important;
    width: 100% !important;
    height: auto !important;
    font-size: medium !important;
    line-height: 200px !important;
  }

  p {
    padding: 0;
  }
`;

const DescriptionField = ({ metadata }) => {
  const { text } = metadata || {};

  if (!text) {
    return null;
  }

  return <ReactMarkdown>{text}</ReactMarkdown>;
};

export default DescriptionField;
